module.exports = __webpack_public_path__ + "static/media/google-icon.5753a2f3.svg";